/**
 * Floating emoji bursts over the live stage.
 */

import React from "react";
import type { FloatingReaction } from "./liveReactionTypes";

type Props = {
  reactions: FloatingReaction[];
};

export function FloatingReactionsOverlay({ reactions }: Props) {
  if (!reactions.length) return null;

  return (
    <div
      aria-hidden
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 40,
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      <style>{`
        @keyframes codelive-reaction-rise {
          0% { opacity: 0; transform: translate(-50%, 20px) scale(0.6); }
          12% { opacity: 1; transform: translate(-50%, 0) scale(1.15); }
          100% { opacity: 0; transform: translate(-50%, -140px) scale(1); }
        }
      `}</style>
      {reactions.map((r) => (
        <div
          key={r.reaction_id}
          style={{
            position: "absolute",
            left: `${r.x}%`,
            bottom: "18%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 4,
            animation: "codelive-reaction-rise 3s ease-out forwards",
          }}
        >
          <span style={{ fontSize: 36, lineHeight: 1, filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.45))" }}>
            {r.emoji}
          </span>
          {r.from_name ? (
            <span
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#e2e8f0",
                background: "rgba(15,20,28,0.7)",
                borderRadius: 999,
                padding: "2px 8px",
                whiteSpace: "nowrap",
                maxWidth: 120,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {r.from_name}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
